import { Breakpoint } from "../layouts";

const widgetConfig = {
  margin: 20,
  rowHeight: 30,
  breakpoints: {
    sm: 0,
    lg: 960,
  },
  // Returns breakpoint for the width
  getBreakpoint(width: number) {
    const breakpoints = Object.keys(this.breakpoints) as Array<Breakpoint>;

    for (let index = 0; index < breakpoints.length; index++) {
      const breakpoint = breakpoints[index];

      if (this.breakpoints[breakpoint] > width) {
        return breakpoints[Math.max(0, index - 1)];
      }
    }

    return breakpoints[breakpoints.length - 1];
  },
};

export default widgetConfig;
